import React from 'react';
import styled from '@emotion/styled';
import { Only } from 'ui/components/elements/Only/Only';
import WhatIfMany from 'ui/images/top_for_buyer/what_if_many.svg';
import ImgPc01 from 'ui/images/top/topService_img01@2x.png';
import LineImg02 from 'ui/images/top/topInterview_img02@2x.png';
import LineImg03 from 'ui/images/top/topInterview_img03@2x.png';
import LineImg04 from 'ui/images/top/topInterview_img04@2x.png';
import FlowLineSpImg from 'ui/images/top_for_buyer/flow_line_sp.svg';
import FlowLineImg from 'ui/images/top_for_buyer/flow_line.svg';
import SearchImg from 'ui/images/top_for_buyer/search.svg';
import HandImg from 'ui/images/top_for_buyer/hand.svg';
import BalloonPart from 'ui/images/top_for_buyer/balloon_part.svg';
import { mqMin } from 'utils/responsive';

const Container = styled.section`
    background-color: var(--light-orange);
    padding: 67px 0 40px 0;

    ${mqMin('NARROW')} {
        padding: 79px 0 43px 0;
    }
`;

const H2 = styled.h2`
    text-align: center;
    color: #fff;
    font-size: 1.09rem;
    line-height: 1.5em;
    letter-spacing: 0.05em;
    margin-bottom: 48px;

    strong {
        font-size: min(6.6vw, 28px);
    }

    ${mqMin('NARROW')} {
        font-size: 1.556rem;
        margin-bottom: 43px;

        strong {
            font-size: 1.6rem;
        }
    }
`;

const QTextContainer = styled.div`
    max-width: 1265px;
    ${mqMin('NARROW')} {
        position: relative;
        margin: 0 auto 0 calc(50% - 31.3rem);
        z-index: 2;
        display: flex;
        justify-content: center;
    }
`;

const QContent = styled.div`
    display: flex;
    align-items: center;
    width: 20.16rem;
    border-radius: 11px;
    background-color: var(--white);
    padding: 1.7rem 1.8rem 1.2rem 1.8rem;
    margin: 0 auto;
    text-align: left;
    position: relative;

    ${mqMin('SP')} {
        width: 35rem;
        max-width: initial;
        margin: 0 auto;
        padding: 2rem;
    }

    ${mqMin('NARROW')} {
        width: 25rem;
        margin: 0;
        padding: 0.889rem;
        text-align: center;
    }
`;

const ImgQWrapper = styled.div`
    width: 7.54rem;
    margin: -20px auto 0 auto;
    z-index: 1;

    ${mqMin('NARROW')} {
        width: 9rem;
        margin: 0 0 0 1rem;
    }
`;

const ImgAWrapper = styled.div`
    width: 5.05rem;
    height: 6.17rem;
    margin: -36px auto 0 auto;

    ${mqMin('NARROW')} {
        margin: -20px auto 0 auto;
    }
`;

const InterviewContentText = styled.div`
    line-height: 1.5em;
    font-size: 0.88rem;
    letter-spacing: 0.1em;
    margin: auto;

    ${mqMin('NARROW')} {
        font-size: 0.778rem;
    }
`;

const InterviewContentLine = styled.div`
    width: 2px;
    height: 51px;
    margin: 25px auto 50px;

    ${mqMin('NARROW')} {
        width: 48.778rem;
        height: 4.611rem;
        margin: 1rem auto;
    }
`;

const InterviewImg = styled.img`
    width: 100%;
    z-index: 1;
    position: relative;
`;

const LinkWrapper = styled.div`
    ${mqMin('NARROW')} {
        display: flex;
        justify-content: space-between;
        max-width: 1312px;
        margin: 0 auto 0 auto;
    }
`;

const LinkItem = styled.div`
    padding-bottom: 55px;

    ${mqMin('NARROW')} {
        margin: 0 10px;
    }
`;

const QLinkContent = styled.div`
    display: flex;
    align-items: center;
    width: 20.16rem;
    border-radius: 11px;
    padding: 1.7rem 1.8rem 1.2rem 1.8rem;
    background-color: var(--white);
    margin: 2.1rem auto 0;
    text-align: left;

    ${mqMin('SP')} {
        width: 35rem;
        max-width: initial;
        padding: 2rem 1.8rem 3rem 1.8rem;
    }

    ${mqMin('NARROW')} {
        margin: 0 auto;
        width: 22.278rem;
        height: 7.167rem;
        max-width: initial;
        padding: initial;
    }
`;

const CompanyName = styled.div`
    text-align: center;
    color: #fff;
    font-size: 0.875rem; /*14px*/
    margin-top: 0.5rem;
    white-space: nowrap;
`;

const WhatIfManyImg = styled.img`
    width: 16.333rem;
    height: auto;
    margin: 0 auto 2rem;
`;

const IconImg = styled.img`
    width: 3.11rem;
    height: auto;
    position: absolute;
    top: -1.5rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;

    ${mqMin('NARROW')} {
        width: 3.167rem;
        top: -1rem;
        left: -1rem;
        transform: none;
    }
`;

const BalloonPartImg = styled.img`
    width: 1.2rem;
    height: auto;
    position: absolute;
    top: 2.6rem;
    right: -1rem;
    display: none;

    ${mqMin('NARROW')} {
        display: block;
    }
`;

export const Interview: React.FC = () => {
    return (
        <Container>
            <H2 className="fadein fadein_y">
                <WhatIfManyImg src={WhatIfMany} alt="WhatIfMany" />
                希望条件を投稿すれば、
                <Only sp>
                    <br />
                </Only>
                複数の仲介会社からのオファーが届く！
            </H2>
            <QTextContainer className="fadein fadein_y">
                <QContent>
                    <IconImg src={SearchImg} alt="検索アイコン" />
                    <InterviewContentText>
                        愛知県周辺で、建設業を営む売上3億円程度、
                        <Only pc>
                            <br />
                        </Only>
                        従業員10名ほどの企業様の買収を検討しています。
                        <Only pc>
                            <br />
                        </Only>
                        案件をお持ちの仲介会社様はいらっしゃいますか？
                    </InterviewContentText>
                    <BalloonPartImg src={BalloonPart} alt="吹き出し" />
                </QContent>
                <ImgQWrapper>
                    <picture>
                        <source media="(min-width: 1024px)" srcSet={ImgPc01} />
                        <InterviewImg src={ImgPc01} alt="Qのイメージ" />
                    </picture>
                </ImgQWrapper>
            </QTextContainer>
            <InterviewContentLine className="fadein fadein_y">
                <picture>
                    <source media="(max-width: 1023px)" srcSet={FlowLineSpImg} />
                    <source media="(min-width: 1024px)" srcSet={FlowLineImg} />
                    <img src={FlowLineImg} alt="" />
                </picture>
            </InterviewContentLine>
            <LinkWrapper>
                <LinkItem className="fadein fadein_y">
                    <QLinkContent>
                        <IconImg src={HandImg} alt="挙手アイコン" />
                        <InterviewContentText>
                            希望条件に合致した案件があります。
                            <br />
                            手数料の目安は総額1500万円ほどです。
                        </InterviewContentText>
                    </QLinkContent>
                    <ImgAWrapper>
                        <InterviewImg src={LineImg02} alt="" />
                        <CompanyName>仲介会社A</CompanyName>
                    </ImgAWrapper>
                </LinkItem>
                <LinkItem className="fadein fadein_y">
                    <QLinkContent>
                        <IconImg src={HandImg} alt="挙手アイコン" />
                        <InterviewContentText>
                            エリア、業種等はマッチしていますが、
                            <Only pc>
                                <br />
                            </Only>
                            少し規模感が小さい会社でしたら案件があります。
                            <Only pc>
                                <br />
                            </Only>
                            手数料は総額1000万円ほどです。
                        </InterviewContentText>
                    </QLinkContent>
                    <ImgAWrapper>
                        <InterviewImg src={LineImg03} alt="" />
                        <CompanyName>仲介会社B</CompanyName>
                    </ImgAWrapper>
                </LinkItem>
                <LinkItem className="fadein fadein_y">
                    <QLinkContent>
                        <IconImg src={HandImg} alt="挙手アイコン" />
                        <InterviewContentText>
                            異なるエリアですが類似の案件があります。
                            <Only pc>
                                <br />
                            </Only>
                            手数料の目安は総額500万円ほどですので、
                            <Only pc>
                                <br />
                            </Only>
                            一度お話を聞いていただけませんか？
                        </InterviewContentText>
                    </QLinkContent>
                    <ImgAWrapper>
                        <InterviewImg src={LineImg04} alt="" />
                        <CompanyName>仲介会社C</CompanyName>
                    </ImgAWrapper>
                </LinkItem>
            </LinkWrapper>
        </Container>
    );
};
